<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">关联后台账号</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-row class="row">
                    <el-col :span="24" class="item">
                        <div class="label">机构名称：{{edit_name}}</div>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24" class="item">
                        <el-tree
                                :data="listStaffAll"
                                show-checkbox
                                default-expand-all
                                node-key="staffCode"
                                ref="tree"
                                highlight-current
                                @check="templateClick"
                                :props="defaultProps">
                        </el-tree>
                    </el-col>
                </el-row>


            </div>

            <div class="modal-footer">
                <el-button type="primary" @click="confirm()">确定</el-button>
            </div>

        </div>
    </div>
</template>

<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";


    export default {
        name: 'EditStaff',
        data() {
            return {

                edit_staffCode:'',
                edit_seatsCode:'',
                edit_name:'',
                edit_governmentCode:'',
                listStaffAll:null,
                defaultProps: {
                    label: 'loginName'
                },
            }
        },

        methods: {
            init(row,){
                this.edit_staffCode = row.staffCode;
                this.edit_seatsCode = row.seatsCode;
                this.edit_name = row.name;
                this.edit_governmentCode = row.governmentCode;
                this.getListStaff();
            },

            closeSelf() {
                this.$emit("closeEditStaff");
            },


            getListStaff(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Staff/PageUnboundForSeats",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        boundStaffCode:this.edit_staffCode,
                        governmentCode:this.edit_governmentCode
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.listStaffAll = response.data.data;
                            this.$refs.tree.setCheckedKeys([this.edit_staffCode]);
                        }
                    }
                )

            },
            templateClick(checkedNodes){
                this.$refs.tree.setCheckedKeys([checkedNodes.staffCode]);
            },
            confirm(){
                let nodes = this.$refs.tree.getCheckedKeys(false,true);
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Seats/BoundStaff",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        boundStaffCode: nodes[0],
                        seatsCode:this.edit_seatsCode,
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.$emit("closeEditStaff");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )

            },


        }
    }


</script>


<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y:auto;
                height: 300px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
